import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent {
  canAccessKpi = false;

  constructor(private authService: AuthService) {
    const currentUserId = this.authService.getCurrentUserId();
    const authorizedUserIds = environment.kpiAuthorizedUserIds || [];
    this.canAccessKpi = !!currentUserId && authorizedUserIds.includes(currentUserId);
  }
} 